export const hmplusVersionListConstants = {
  HMPLUSVERSION_LIST_LOADING: "HMPLUSVERSION_LIST_LOADING",
  HMPLUSVERSION_LIST_SUCCESS: "HMPLUSVERSION_LIST_SUCCESS",
  HMPLUSVERSION_LIST_FAILURE: "HMPLUSVERSION_LIST_FAILURE",
};

export const hmplusVersionUploadConstants = {
  HMPLUSVERSION_UPLOAD_LOADING: "HMPLUSVERSION_UPLOAD_LOADING",
  HMPLUSVERSION_UPLOAD_SUCCESS: "HMPLUSVERSION_UPLOAD_SUCCESS",
  HMPLUSVERSION_UPLOAD_FAILURE: "HMPLUSVERSION_UPLOAD_FAILURE",
};

export const hmplusVersionConstants = {
  HMPLUSVERSION_LOADING: "HMPLUSVERSION_LOADING",
  HMPLUSVERSION_SUCCESS: "HMPLUSVERSION_SUCCESS",
  HMPLUSVERSION_FAILURE: "HMPLUSVERSION_FAILURE",
};

export const hmplusVersionDeleteConstants = {
  HMPLUSVERSION_DELETE_LOADING: "HMPLUSVERSION_DELETE_LOADING",
  HMPLUSVERSION_DELETE_SUCCESS: "HMPLUSVERSION_DELETE_SUCCESS",
  HMPLUSVERSION_DELETE_FAILURE: "HMPLUSVERSION_DELETE_FAILURE",
};
